function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("title", null, "THINK");

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M22.4,19.7H0V2.1h64.7v17.6H42.3v49.6h-20L22.4,19.7z M133.1,2.1v67.2h-20V44.6H89.5v24.8h-20V2.1h20v23.8h23.6V2.1H133.1z M139,2.1h20v67.2h-20V2.1z M231.7,2.1h20v67.2h-20V2.1z M225.8,2.1v67.2h-16l-25.5-33.2v33.2h-19.4V2.1h15.9l25.5,33.2V2.1H225.8z M274.9,69.3l-24.5-33.9L275,2.1h21.7l-23.3,32.5l24.8,34.8H274.9z"
});

var SvgThinkLogo = function SvgThinkLogo(props) {
  return React.createElement("svg", _extends({
    id: "THINK",
    viewBox: "0 0 299 72",
    style: {
      enableBackground: "new 0 0 299 72"
    },
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZwogIHZlcnNpb249IjEuMSIKICBpZD0iVEhJTksiCiAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIgogIHZpZXdCb3g9IjAgMCAyOTkgNzIiCiAgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMjk5IDcyOyIKICB4bWw6c3BhY2U9InByZXNlcnZlIgo+CiAgPHRpdGxlPlRISU5LPC90aXRsZT4KICA8cGF0aCBkPSJNMjIuNCwxOS43SDBWMi4xaDY0Ljd2MTcuNkg0Mi4zdjQ5LjZoLTIwTDIyLjQsMTkuN3ogTTEzMy4xLDIuMXY2Ny4yaC0yMFY0NC42SDg5LjV2MjQuOGgtMjBWMi4xaDIwdjIzLjhoMjMuNlYyLjFIMTMzLjF6IE0xMzksMi4xaDIwdjY3LjJoLTIwVjIuMXogTTIzMS43LDIuMWgyMHY2Ny4yaC0yMFYyLjF6IE0yMjUuOCwyLjF2NjcuMmgtMTZsLTI1LjUtMzMuMnYzMy4yaC0xOS40VjIuMWgxNS45bDI1LjUsMzMuMlYyLjFIMjI1Ljh6IE0yNzQuOSw2OS4zbC0yNC41LTMzLjlMMjc1LDIuMWgyMS43bC0yMy4zLDMyLjVsMjQuOCwzNC44SDI3NC45eiIgLz4KPC9zdmc+Cg==";
export { SvgThinkLogo as ReactComponent };